import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { onboardStudent } from "@user-management-context/write/application/use-cases/student-onboarding/onboard-student";
import { selectStudentOnboarding } from "@user-management-context/write/application/use-cases/student-onboarding/selectors/student-onboarding-selectors";
import type { OnboardStudentBody } from "@shared-kernel/application/ports/shared/shared-repository";
import { StudentOnboarding } from "./student-onboarding.content";
import { useStudentOnboarding } from "./use-student-onboarding";

export const StudentOnboardingContainer = () => {
  const dispatch = useAppDispatch();
  const { processing } = useAppSelector(selectStudentOnboarding);

  useStudentOnboarding();

  const handleSubmit = (body: OnboardStudentBody) => {
    dispatch(onboardStudent(body));
  };

  return <StudentOnboarding onSubmit={handleSubmit} submitting={processing === "pending"} />;
};
